import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth/auth-service';
import { MonitoringControllerService } from '../../services/monitoring-controller/monitoring-controller.service';
import { BpaSettingsService } from '../../services/bpa-settings.service';
import { BPASettings } from '@models/bpa-settings';
import { MessageControllerService } from '../../services/message-controller.service';
import { WebSocketMessageType } from '../../enums';
import { WebsocketService } from '../../services/websocket.service';
import { GlobalStateProviderService } from '../../services/global-state-provider.service';
import { Subscription } from 'rxjs';
import { BusinessEntity } from '@models/business-entity';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('messagesDialog') messagesDialog!: ElementRef<HTMLDialogElement>;
  unSeenMessagesCount: number = 0;
  areMessagesLoaded: boolean = false;
  totalMessagesCount: number = 0;
  currentBE: BusinessEntity | null = null;
  siteName: string = '';
  logoSrc: string = '';
  public version: string = '';
  // eslint-disable-next-line no-undef
  public static feMonitor: NodeJS.Timeout;
  public isLocal: boolean = environment.LOCAL;
  private bpaSettingsSubscription?: Subscription;
  private subscription?: Subscription;
  private openMessagesDialogSubscription?: Subscription;
  public showSiteName: boolean = environment.SHOW_SITE_NAME;
  public isMainNavigationOpen: boolean = false;

  constructor(
    public authService: AuthService,
    public monitoringControllerService: MonitoringControllerService,
    private readonly bpaSettings: BpaSettingsService,
    private readonly messageController: MessageControllerService,
    private readonly webSocket: WebsocketService,
    private readonly globalStateProviderService: GlobalStateProviderService
  ) {
    this.logoSrc = `${environment.BASE_URL}logo`;
  }

  public ngOnInit() {
    this.bpaSettingsSubscription = this.bpaSettings
      .getBpaSettings$()
      .subscribe((bpaSettings: BPASettings | null) => {
        if (bpaSettings) {
          this.siteName = bpaSettings.siteName ?? '';
        }
      });
    if (!this.isLocal) {
      clearTimeout(HeaderComponent.feMonitor);
      this.monitorFe();
    }
    this.subscription = this.webSocket.messageReceived$.subscribe((message) => {
      switch (message?.type) {
        case WebSocketMessageType.NEW_MESSAGE:
        case WebSocketMessageType.NEW_ALERT_MESSAGE:
          this.getUnseenMessagesCount();
          break;
      }
    });

    // Subscribe to open messages dialog from anywhere in the app (e.g., toast click)
    this.openMessagesDialogSubscription =
      this.globalStateProviderService.openMessagesDialog$.subscribe(() => {
        this.openMessagesDialog();
      });
  }

  public monitorFe() {
    // reason for this monitoring to be here is for user not getting logged out while being on idle
    this.monitoringControllerService.getFEVersion().subscribe(
      (data: any) => {
        this.version = data?.version;
        HeaderComponent.feMonitor = setTimeout(() => this.monitorFe(), 60000);
      },
      () => {
        this.version = '';
        HeaderComponent.feMonitor = setTimeout(() => this.monitorFe(), 60000);
      }
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.bpaSettingsSubscription) {
      this.bpaSettingsSubscription.unsubscribe();
    }
    if (this.openMessagesDialogSubscription) {
      this.openMessagesDialogSubscription.unsubscribe();
    }
    clearTimeout(HeaderComponent.feMonitor);
  }

  public openMessagesDialog() {
    this.messagesDialog.nativeElement.showModal();
  }

  public closeMessagesDialog() {
    this.messagesDialog.nativeElement.close();
  }

  public toggleMainNavigation() {
    this.isMainNavigationOpen = !this.isMainNavigationOpen;
  }

  private getUnseenMessagesCount() {
    this.messageController.getUnSeenCount().subscribe((result) => {
      this.unSeenMessagesCount = result;
      this.areMessagesLoaded = true;
    });
  }

  updateUnSeenMessageCount(count: number) {
    this.unSeenMessagesCount = count;
  }

  updateTotalMessagesCount(count: number) {
    this.totalMessagesCount = count;
  }
}
